/**
 * Winter Impact Prediction (WIP) & Region API Service
 *
 * WIP district flow:
 *   scenarios/parameters → scenarios/match → scenarios/{id}/impacts
 *
 * Region flow:
 *   scenarios/parameters(view_type=region) → region-impacts
 */

import api from "../client";
import { ENDPOINTS } from "../endpoints";
import type {
  ScenarioParametersResponse,
  ScenarioParameterValues,
  ScenarioViewType,
  WIPScenarioResponse,
  WIPDistrictImpactsResponse,
  RegionImpactQueryParams,
  RegionImpactResponse,
} from "../types";

export const wipApi = {
  /** GET /api/v1/storms/{id}/scenarios/parameters */
  getScenarioParameters: (
    stormId: string,
    stormApplicationId: string,
    viewType: ScenarioViewType,
  ) =>
    api.get<ScenarioParametersResponse>(
      ENDPOINTS.SCENARIO_PARAMETERS(stormId),
      {
        params: {
          storm_application_id: stormApplicationId,
          view_type: viewType,
        },
      },
    ),

  /** GET /api/v1/storms/{id}/scenarios/match */
  matchScenario: (
    stormId: string,
    stormApplicationId: string,
    viewType: ScenarioViewType,
    params: ScenarioParameterValues,
  ) =>
    api.get<WIPScenarioResponse>(ENDPOINTS.SCENARIO_MATCH(stormId), {
      params: {
        storm_application_id: stormApplicationId,
        view_type: viewType,
        parameters: JSON.stringify(params),
      },
    }),

  /** GET /api/v1/storms/scenarios/{id}/impacts */
  getImpacts: (scenarioMetadataId: string) =>
    api.get<WIPDistrictImpactsResponse>(
      ENDPOINTS.SCENARIO_IMPACTS(scenarioMetadataId),
    ),

  /** GET /api/v1/storms/{id}/scenarios/parameters?view_type=region */
  getRegionMetadata: (stormId: string, stormApplicationId: string) =>
    wipApi.getScenarioParameters(stormId, stormApplicationId, "region"),

  /** GET /api/v1/storms/{id}/region-impacts */
  getRegionImpacts: (
    stormId: string,
    stormApplicationId: string,
    params: RegionImpactQueryParams,
  ) =>
    api.get<RegionImpactResponse>(ENDPOINTS.REGION_IMPACTS(stormId), {
      params: {
        storm_application_id: stormApplicationId,
        parameters: JSON.stringify(params),
      },
    }),
};
